var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadQueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8281 2H1.17188C0.524597 2 0 2.15937 0 2.35602V4.64398C0 4.84063 0.524597 5 1.17188 5H38.8281C39.4754 5 40 4.84063 40 4.64398V2.35602C40 2.15937 39.4754 2 38.8281 2Z",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6162 32H16.3838C15.6195 32 15 32.1594 15 32.356V34.644C15 34.8406 15.6195 35 16.3838 35H38.6162C39.3805 35 40 34.8406 40 34.644V32.356C40 32.1594 39.3805 32 38.6162 32Z",
    fill: "#696969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8281 12H1.17188C0.524597 12 0 12.1594 0 12.356V14.644C0 14.8406 0.524597 15 1.17188 15H38.8281C39.4754 15 40 14.8406 40 14.644V12.356C40 12.1594 39.4754 12 38.8281 12Z",
    fill: "#696969"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8281 22H1.17188C0.524597 22 0 22.1594 0 22.356V24.644C0 24.8406 0.524597 25 1.17188 25H38.8281C39.4754 25 40 24.8406 40 24.644V22.356C40 22.1594 39.4754 22 38.8281 22Z",
    fill: "#696969"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49963 31.75H1.99963C1.30963 31.75 0.749634 32.31 0.749634 33C0.749634 33.69 1.30963 34.25 1.99963 34.25H9.49963C10.1896 34.25 10.7496 33.69 10.7496 33C10.7496 32.31 10.1896 31.75 9.49963 31.75Z",
    fill: "#696969"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88298 36.3837L10.383 33.8837C10.8713 33.3954 10.8713 32.6054 10.383 32.1171L7.88298 29.6171C7.39631 29.1287 6.60298 29.1287 6.11631 29.6171C5.62798 30.1037 5.62798 30.8971 6.11631 31.3837L7.73131 33.0004L6.11631 34.6171C5.62798 35.1037 5.62798 35.8971 6.11631 36.3837C6.60298 36.8721 7.39631 36.8721 7.88298 36.3837Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadQueIcon);
export default __webpack_public_path__ + "static/media/upload_que_icon.a8498b15c060c3563075673e36f24486.svg";
export { ForwardRef as ReactComponent };